import * as yup from "yup";
import { PaymentMethod } from "./PaymentMethod.ts";
import {
  PaymentMethodConfig,
  StripeConfigDTO,
} from "./PaymentMethodConfiguration.ts";
import { StripeConfigFields } from "./StripeConfigurationFields.tsx";

const stripeValidationSchema = yup
  .object({
    succeededUrl: yup
      .string()
      .url("URL non valido")
      .required("URL di successo obbligatorio per Stripe"),
    failedUrl: yup.string().url("URL non valido").optional(),
    oneTimeEnabled: yup.boolean().optional(),
    installmentsEnabled: yup.boolean().optional(),
    allowedTerms: yup
      .array()
      .of(yup.number().required())
      .when("installmentsEnabled", {
        is: true,
        then: (schema) =>
          schema
            .min(1, "Devi selezionare almeno un numero di rate")
            .required("Numero di rate obbligatorio"),
        otherwise: (schema) => schema.optional(),
      }),
  })
  .test(
    "at-least-one-payment-type",
    {
      message:
        "Devi abilitare almeno un tipo di pagamento (rate o soluzione unica)",
      path: "paymentTypeError",
    },

    function (values) {
      return (
        values.oneTimeEnabled === true || values.installmentsEnabled === true
      );
    },
  );
export const StripePaymentMethodConfig: PaymentMethodConfig<StripeConfigDTO> = {
  method: PaymentMethod.Stripe,
  configFieldName: "stripeConfig",
  validationSchema: stripeValidationSchema,
  ConfigComponent: StripeConfigFields,
  defaultValues: {
    succeededUrl: "",
    failedUrl: "",
    installmentsEnabled: false,
    oneTimeEnabled: true,
    allowedTerms: [],
  },
};
